const CAP_COMPARISON_FEATURE_LIST = [
  "Locked in predictable payment",
  "Avoid expensive peak-hour utility pricing",
  "Grid outage protection",
  "Distributed power plant program (if avail)",
  "Guaranteed energy access",
];

const CAP_UTILITY_RECAP = {
  recapBadge: "Problem Recap",
  headline: "You're 100% dependent on the utility",
  bodyLines: [
    "Your prices are increasing and access to power is not guaranteed.",
  ],
  gaugePercent: 0,
  gaugeLabel: "No solar offset",
};

const CAP_SOLAR_RECAP = {
  recapBadge: "Solution Recap",
  headline: "You're in control of your energy",
  bodyLines: [
    "Lock in predictable payments and guarantee your access to energy",
  ],
};

export { CAP_COMPARISON_FEATURE_LIST, CAP_SOLAR_RECAP, CAP_UTILITY_RECAP };
